import * as Action from "@actions/index";
import * as Model from "@models/index";
import { useDispatch } from "@helpers/Store";

export default class NetworkingExponentPlatinum {
  public static async page(page: number, filters?: any) {
    try {
      useDispatch(Action.Networking.Exponent.Platinum.setStatus("loading"));
      const response = await new Model.Networking.Exponent.Platinum().page(page, filters);
      useDispatch(Action.Networking.Exponent.Platinum.setData(response.data));
      useDispatch(Action.Networking.Exponent.Platinum.setStatus("loaded"));
      return response.data;
    } catch (Exception) {
      throw Exception;
    }
  }
}
